import React from 'react';

const BreadcrumbTitle = (props)=>{
    var session = sessionStorage.getItem('health_facilities_name');
    return (
        <div className="route">
            <h5 className="title_page" >
                {session + ' -> ' + props.menu + ' -> ' + props.page}                
            </h5>
        </div>
    )
}

export default BreadcrumbTitle;